import { AxiosPromise } from 'axios';
import { instance } from '.';
import { URLS } from './index';
import { Logger } from 'fsts';
import { LogEntityType, LogEntry } from '../model/logEntry';

const logger = new Logger('backend.EventLog');

export interface BackendEventLog {
  getEventLog(entityType: LogEntityType, entityId: string): AxiosPromise<LogEntry[]>;
}

export const DefaultBackendEventLog: BackendEventLog = {
  getEventLog(entityType: LogEntityType, entityId: string): AxiosPromise<LogEntry[]> {
    const url = `${URLS.eventLog}/GetLog/${entityType}/${entityId}`;
    logger.debug('getEventLog: ' + url);
    return instance.get(url);
  },
};